



































































































import {
  defineComponent, computed,
} from '@vue/composition-api';

import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import { useQuery } from '@vue/apollo-composable';

import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';
import ChartWithSelectedMonth from '@/components/Report/ChartWithSelectedMonth.vue';
import DoughnutHub from '@/components/Report/01-Income/DoughnutHub.vue';
import HeatMapIncome from '@/components/Report/01-Income/HeatmapIncome.vue';
import TreemapArea from '@/components/Report/01-Income/TreemapArea.vue';
import TableIncomeUnit from '@/components/Report/01-Income/TableIncomeUnit.vue';
import TableIncomeProductType from '@/components/Report/01-Income/TableIncomeProductType.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';

import monthsIncome from '@/gql/managementReport/01-Income/monthsIncome.gql';
import incomeRange from '@/gql/managementReport/01-Income/incomeRange.gql';
import incomeStats from '@/gql/managementReport/01-Income/incomeStats.gql';
import incomeByHub from '@/gql/managementReport/01-Income/incomeByHub.gql';
import incomeByArea from '@/gql/managementReport/01-Income/incomeByArea.gql';
import incomeByUnit from '@/gql/managementReport/01-Income/incomeByUnit.gql';
import incomeByProvince from '@/gql/managementReport/01-Income/incomeByProvince.gql';
import incomeByProductType from '@/gql/managementReport/01-Income/incomeByProductType.gql';

const DeliveryIncome = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithLastYearCompare,
    ChartWithSelectedMonth,
    DoughnutHub,
    TreemapArea,
    TableIncomeUnit,
    TableIncomeProductType,
    HeatMapIncome,
  },
  setup() {
    const { result: getTopInfo } = useQuery(incomeStats, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeMTD: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.incomeStats || []);
    const getPanelInfoMtd = computed(() => getTopInfo.value?.incomeStatsMTD || []);
    return {
      // Queries that passthrough component
      monthsIncome,
      incomeRange,
      incomeStats,
      incomeByHub,
      incomeByArea,
      incomeByUnit,
      incomeByProductType,
      incomeByProvince,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default DeliveryIncome;
